export const LOCALES = ["es-MX", "en-US"] as const
export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = "es-MX"
// Fallback intentionally points at Spanish — if a key is missing from en-US
// we'd rather show Spanish than the raw key.
export const FALLBACK_LOCALE: Locale = "es-MX"

export const NAMESPACES = [
  "common",
  "auth",
  "home",
  "classrooms",
  "students",
  "materials",
  "settings",
  "onboarding",
  "errors",
  "surveys",
  "direction",
  "home_demo",
  "ocr",
  "grading",
  // PRD-24 — public student photo upload portal. ``portal`` is es-MX-only
  // per PRD-24 §FR-8.3 (Mexican secondary-school students are the audience;
  // adding an en-US bundle would be parity-test cost forever for an
  // audience that does not exist). The keys-parity test exempts this
  // namespace from the en-US round-trip — see i18n/__tests__/keys.test.ts.
  "portal",
  // PRD-26 — notification bell + dropdown + /notificaciones page.
  "notifications",
  // PRD-28 — in-app feedback / bug-report modal + sidebar entry.
  "feedback",
  // PRD-33 / ADR-0030 — public account-activation (set-password) page at
  // /activar/:token. Full es-MX + en-US parity (professors are first-class
  // account holders, not the es-MX-only student audience).
  "account-activation",
  // PRD-40 — unified per-student page at /alumnos/:profileId.
  "student-profile",
  // PRD-48 — professor-only adaptive level review and evidence history.
  "adaptive-levels",
  // PRD-64 — the professor's reference sources at /fuentes.
  "references",
  "class-notes",
  "lesson-plans",
] as const
export type Namespace = (typeof NAMESPACES)[number]

// PRD-24 §FR-8.3 — namespaces that are intentionally es-MX-only. The
// keys-parity test reads this list and skips the en-US side for these.
export const ES_MX_ONLY_NAMESPACES: ReadonlyArray<Namespace> = ["portal"] as const

export const LOCALE_STORAGE_KEY = "platonica_locale"

export const LOCALE_LABELS: Record<Locale, string> = {
  "es-MX": "Español (MX)",
  "en-US": "English (US)",
}
